import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionHeading({ title, subtitle, to, linkLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div>
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-50 flex items-center gap-2.5">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-400 mt-2 ml-3.5">{subtitle}</p>}
      </div>
      {to && (
        <Link
          to={to}
          className="text-sm text-foreground-300 hover:text-primary-400 flex items-center gap-1 whitespace-nowrap shrink-0 transition-colors"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}